document.addEventListener('DOMContentLoaded', function () {
  // 轮播间隔（毫秒）：可按需改
  var INTERVAL = 3000;

  // 选取 Dawn 公告栏容器（不同版本类名略有差异，以下做了尽量兼容）
  var bars = document.querySelectorAll('.announcement-bar, [data-section-type="announcement-bar"]');

  if (!bars.length) return;

  bars.forEach(function (bar) {
    // 找到展示文本的元素（多适配几种常见结构）
    var textEl =
      bar.querySelector('.announcement-bar__message') ||
      bar.querySelector('.announcement-bar__content') ||
      bar.querySelector('[data-announcement-text]') ||
      bar; // 兜底

    if (!textEl) return;

    var raw = (textEl.textContent || '').trim();

    // 按 || 分隔
    var items = raw.split('||').map(function (s) { return s.trim(); }).filter(Boolean);

    // 如果不到两条，就不轮播
    if (items.length < 2) return;

    // 构建轮播容器
    var wrapper = document.createElement('span');
    wrapper.className = 'announcement-rotator';
    // 保证单行
    wrapper.style.whiteSpace = 'nowrap';
    wrapper.style.display = 'inline-block';
    wrapper.style.verticalAlign = 'middle';

    // 用 span 渲染每一条
    items.forEach(function (msg, idx) {
      var span = document.createElement('span');
      span.className = 'announcement-rotator__item';
      span.textContent = msg;
      // 初始只显示第一条
      span.style.display = idx === 0 ? 'inline' : 'none';
      span.style.transition = 'opacity 300ms ease';
      wrapper.appendChild(span);
    });

    // 替换原文字
    textEl.textContent = '';
    textEl.appendChild(wrapper);

    // 轮播逻辑
    var i = 0;
    var spans = wrapper.querySelectorAll('.announcement-rotator__item');
    var timer = null;

    function show(next) {
      spans[i].style.display = 'none';
      i = next;
      spans[i].style.display = 'inline';
    }

    function tick() {
      var next = (i + 1) % spans.length;
      show(next);
    }

    // 无障碍/低动效支持：用户偏好减少动效则不自动轮播
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduce) {
      timer = setInterval(tick, INTERVAL);

      // 鼠标悬停暂停（可选）
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', function () { timer = setInterval(tick, INTERVAL); });
    }
  });
});
